const allowedColors: { [key: string]: string } = {
    'beige': 'var(--color-base-brand-beige)',
    'black': 'var(--color-base-brand-black)',
    'red': 'var(--color-base-brand-red)',
    'white': 'var(--color-base-brand-white)',
};

export default (textColor: string) => ({ color: allowedColors[textColor] || allowedColors.black });
